var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProofOfAddress = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 327 252"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 327,
  height: 252,
  fill: "#fff",
  rx: 16
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 207,
  x: 84.5,
  y: 22.5,
  fill: "#F9F9F8",
  rx: 16
}), /*#__PURE__*/React.createElement("rect", {
  width: 157,
  height: 206,
  x: 85,
  y: 23,
  stroke: "#000",
  strokeOpacity: 0.1,
  rx: 15.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 138,
  height: 41,
  x: 94.5,
  y: 32.5,
  fill: "#FFEB7C",
  rx: 8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#242424",
  d: "m116.404 50.124-6.038-4.432a1.46 1.46 0 0 0-1.728 0l-6.042 4.432a1.46 1.46 0 0 0-.596 1.178v6.667a2.44 2.44 0 0 0 2.438 2.438h2.051a.98.98 0 0 0 .975-.975v-2.79c0-1.118.911-2.029 2.028-2.029a2.03 2.03 0 0 1 2.029 2.029v2.79c0 .536.439.975.975.975h2.066A2.44 2.44 0 0 0 117 57.969v-6.667a1.47 1.47 0 0 0-.596-1.178"
}), /*#__PURE__*/React.createElement("rect", {
  width: 102,
  height: 6,
  x: 124.5,
  y: 40,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 0.529
}), /*#__PURE__*/React.createElement("rect", {
  width: 102,
  height: 6,
  x: 124.5,
  y: 50,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 0.529
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 6,
  x: 124.5,
  y: 60,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 0.529
}), /*#__PURE__*/React.createElement("rect", {
  width: 138,
  height: 6,
  x: 94.5,
  y: 83.5,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 138,
  height: 6,
  x: 94.5,
  y: 95.5,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 138,
  height: 6,
  x: 94.5,
  y: 107.5,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 138,
  height: 6,
  x: 94.5,
  y: 119.5,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 18,
  x: 94.5,
  y: 135.5,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 6,
  x: 168.5,
  y: 135.5,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 6,
  x: 168.5,
  y: 147.5,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 138,
  height: 6,
  x: 94.5,
  y: 163.5,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 138,
  height: 6,
  x: 94.5,
  y: 175.5,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 55,
  height: 6,
  x: 94.5,
  y: 191.5,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 55,
  height: 6,
  x: 94.5,
  y: 203.5,
  fill: "#000",
  fillOpacity: 0.1,
  rx: 2
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#006626",
  d: "M243 196.833c-13.328 0-24.167 10.839-24.167 24.167s10.839 24.167 24.167 24.167 24.167-10.839 24.167-24.167-10.839-24.167-24.167-24.167m10.911 17.594-12.736 16.602a1.58 1.58 0 0 1-1.244.616c-.326 0-.665-.108-.943-.314l-6.597-5.002a1.574 1.574 0 0 1-.302-2.199 1.575 1.575 0 0 1 2.199-.303l5.353 4.06 11.781-15.357a1.563 1.563 0 0 1 2.199-.29c.689.531.822 1.51.29 2.199z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 178,
  height: 227,
  x: 74.5,
  y: 16.5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2524_17854"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2524_17854",
  result: "shape"
})))));
export { SvgProofOfAddress as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/shared/containers/app/documentCapture/uploadDocuments/pages/IncodeSDKPage/assets/ProofOfAddress.svg", import.meta.url).toString();